var map = {
	"./lesson_4_1.pdf": 992,
	"./lesson_4_2.pdf": 993,
	"./lesson_4_3.pdf": 994,
	"./lesson_4_4.pdf": 995,
	"./lesson_4_5.pdf": 996,
	"./lesson_4_6.pdf": 997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 991;